import { useTranslate } from '../translate/I18n';
import { useMemo } from 'react';
import { CURRENCY_EURO } from '../components/molecules/form/InputCurrency';

export const useMoney = () => {
  const { i18n } = useTranslate();
  return useMemo(() => {
    return {
      formatRange: function (range, currency) {
        return [range.min, range.max]
          .filter(p => !!p)
          .map(p => this.format(p, currency))
          .join('-');
      },
      format: function (price, currency) {
        return new Intl.NumberFormat(i18n.language, {
          style: 'currency',
          currency: currency || CURRENCY_EURO,
          minimumFractionDigits: 0
        }).format(price);
      }
    };
  }, [i18n.language]);
};
